<template>
  <div class="store-skeleton">
    <slot />
  </div>
</template>

<style lang="scss">
  @keyframes skeleton-loading {
    0% {
      @apply bg-neutral-high-medium bg-opacity-semiopaque;
    }
    100% {
      @apply bg-neutral-high-light bg-opacity-semiopaque;
    }
  }

  .store-skeleton {
    @apply bg-neutral-low-light rounded-md;
    animation: skeleton-loading 1s linear infinite alternate;
  }
</style>
